import promoEnvFlags from '../../config/promoEnvFlags';

/** Campaign lifecycle states — only ACTIVE renders outside preview mode. */
export const PROMO_CAMPAIGN_STATUS = {
  DRAFT: 'DRAFT',
  QA: 'QA',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  EXPIRED: 'EXPIRED',
};

/** Promotional surface identifiers — reuse with canShowPromotion(surface). */
export const PROMO_SURFACES = {
  HOMEPAGE_POPUP: 'homepagePopup',
  FLIGHT_RESULTS_BANNER: 'flightResultsBanner',
  FLIGHT_PREVIEW_BANNER: 'flightPreviewBanner',
  HOMEPAGE_SEARCH_BANNER: 'homepageSearchBanner',
};

/** Zero-fee homepage popup: once per browser tab, then again after 24 hours. */
export const HOMEPAGE_POPUP_COOLDOWN_MS = 24 * 60 * 60 * 1000;

/**
 * Single source of truth for convenience fee campaign flags, lifecycle, and surface config.
 * Global env overrides: see client/src/config/promoEnvFlags.js
 */
export const PROMO_CONFIG = {
  flags: {
    /** Master kill switch — REACT_APP_PROMO_ENABLED=false disables all surfaces. */
    enabled: promoEnvFlags.enabled,
    /** QA env mode — REACT_APP_PROMO_QA_MODE=true bypasses status and dates. Homepage popup cooldown stays on. */
    previewMode: promoEnvFlags.qaMode,
    homepagePopup: true,
    flightResultsBanner: true,
    flightPreviewBanner: true,
    homepageSearchBanner: true,
  },
  campaign: {
    status: PROMO_CAMPAIGN_STATUS.ACTIVE,
    /** ISO date string or null — null means no start restriction. */
    startDate: null,
    /** ISO date string or null — null means no end restriction. */
    endDate: null,
    eligibility: {
      guest: true,
      authenticated: true,
    },
  },
  surfaces: {
    homepagePopup: {
      showDelayMs: 800,
      /**
       * Zero-fee popup on / and /flights.
       * Once per browser tab (sessionStorage). Shows again after 24 hours.
       * Enforced even in QA mode so hotel → flight navigation does not repeat it.
       */
      cooldownMs: HOMEPAGE_POPUP_COOLDOWN_MS,
      enforceCooldown: true,
      storage: 'session',
      allowedRoutes: ['/', '/flights'],
      storageKey: 'convFeePromoLastShown',
    },
    flightResultsBanner: {
      allowedRoutes: ['/flight', '/flight-search-results'],
      /** SEO cached results — e.g. /flights/delhi-to-bangalore */
      allowedRoutePrefixes: ['/flights/'],
      /** No cooldown — homepage popup only uses impression cooldown. */
      cooldownMs: 0,
    },
    flightPreviewBanner: {
      allowedRoutes: ['/flight-preview'],
      /** No cooldown — homepage popup only uses impression cooldown. */
      cooldownMs: 0,
    },
    homepageSearchBanner: {
      allowedRoutes: ['/', '/flights'],
      /** No cooldown — always visible on flight homepage search widget. */
      cooldownMs: 0,
    },
  },
  cta: {
    guest: 'Book Now',
    authenticated: 'Book Now',
  },
};
